import { useExportHook, useExportProps } from './types';
import { useEffect, useState } from 'react';
import { useCustomQuery } from '@gripp/shared-logic';
import { getDateFilter } from './dateFilterUtils';

export const useActivityExport: useExportHook = (props: useExportProps) => {
  const [rows, setRows] = useState([]);
  const { data, isLoading } = useCustomQuery({
    cacheKey: ['exportActivities', props.workspace.id, props.dateFilter],
    query: EXPORT_ACTIVITIES,
    variables: {
      filter: {
        workspaceId: props.workspace.id,
        ...getDateFilter(props.dateFilter),
      },
    },
    options: {
      enabled: props.download,
      gcTime: 10000,
      staleTime: 10000,
    },
  });

  const headers = [
    { label: 'Asset ID', key: 'assetId' },
    { label: 'Asset Name', key: 'assetName' },
    { label: 'Activity ID', key: 'activityId' },
    { label: 'Activity Title', key: 'activityTitle' },
    { label: 'Activity Type', key: 'activityType' },
    { label: 'Activity Created By', key: 'activityCreatedBy' },
    { label: 'Activity Created Date', key: 'activityCreatedDate' },
    { label: 'Activity Created Time', key: 'activityCreatedTime' },
    { label: 'Activity Creation UTC', key: 'activityCreationUtc' },
    { label: 'Message ID', key: 'messageId' },
    { label: 'Message Text', key: 'messageText' },
    { label: 'Message Created By', key: 'messageCreatedBy' },
    { label: 'Message Created Date', key: 'messageCreatedDate' },
    { label: 'Message Created Time', key: 'messageCreatedTime' },
    { label: 'Message Creation UTC', key: 'messageCreationUtc' },
    { label: 'Groups', key: 'groups' },
  ];

  useEffect(() => {
    if (!data) return;

    const exportRows = data.issue.exportActivity.data.map((item: any) => {
      const row = { ...item };

      // Split activityCreatedAt
      if (item.activityCreatedAt) {
        const date = new Date(item.activityCreatedAt);
        row.activityCreatedDate = date.toLocaleDateString();
        row.activityCreatedTime = date.toLocaleTimeString();
        row.activityCreationUtc = date.toISOString();
      }

      // Split messageCreatedAt
      if (item.messageCreatedAt) {
        const date = new Date(item.messageCreatedAt);
        row.messageCreatedDate = date.toLocaleDateString();
        row.messageCreatedTime = date.toLocaleTimeString();
        row.messageCreationUtc = date.toISOString();
      }

      return row;
    });

    setRows(exportRows);
    props.onDataReady();
  }, [data]);

  return {
    headers,
    rows,
    isLoading,
  };
};

const EXPORT_ACTIVITIES = `
  query Issue($filter: ExportActivityFilter) {
    issue {
      exportActivity(filter: $filter) {
        data {
          activityCreatedAt
          activityCreatedBy
          activityId
          activityTitle
          activityType
          assetId
          assetName
          messageCreatedAt
          messageCreatedBy
          messageId
          messageText
          groups
        }
      }
    }
  } 
`;
